import React from 'react';

const HomeEditBannerOne = ({ themeData }: any) => {
  return (
    <div
      className="wash-fold-section"
      style={{
        background: `var(--primary-color) url(${themeData?.theme_5?.home?.section_5?.banner}) no-repeat top center`,
      }}
    >
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="wash-fold-card">
              <div className="wash-fold-text">
                <h2
                  style={{
                    color: `#${themeData?.theme_5?.home?.section_5?.h2color}`,
                  }}
                >
                  {themeData?.theme_5?.home?.section_5?.title}
                </h2>
              </div>
              <div className="wash-fold-info">
                <ul>
                  {themeData?.theme_5?.home?.section_5?.wash_title?.map(
                    (item: any) => {
                      return (
                        <>
                          <li>
                            <i className="fa fa-check"></i>{' '}
                            <p
                              style={{
                                color: `#${themeData?.theme_5?.home?.section_5?.paracolor}`,
                              }}
                            >
                              {item?.wash_list}
                            </p>
                          </li>
                        </>
                      );
                    }
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeEditBannerOne;
